import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import es from './locales/es.json';

// Storage can become unavailable after detection (private mode, permissions or quota).
const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'safeLocalStorage',
  lookup: ({ lookupLocalStorage }) => {
    try { return lookupLocalStorage ? window.localStorage.getItem(lookupLocalStorage) || undefined : undefined; }
    catch { return undefined; }
  },
  cacheUserLanguage: (lng, { lookupLocalStorage }) => {
    try { if (lookupLocalStorage) window.localStorage.setItem(lookupLocalStorage, lng); }
    catch { /* Language switching still works without persistence. */ }
  },
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng.split('-')[0];
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    load: 'languageOnly',
    detection: {
      order: ['safeLocalStorage', 'navigator'],
      caches: ['safeLocalStorage'],
      lookupLocalStorage: 'ar_concept_lang',
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
